import { di } from 'react-magnetic-di';
import { UiModificationsScreenTabsValidationError } from '../../utils/errors/ui-modifications-screentabs-validation-error';
import { toScreenTabsValidationError } from '../../utils/errors/utils';
import { collectScreenTabsAppliedChangesHistory } from '../applied-changes-history/collect-history';
import { getScreenTabsPublicToInternalValidationErrors, screenTabsPublicToInternalTransformer, screenTabsPublicToInternalValidator } from './utils';
/**
 * Update screen tabs store data from changes coming from UI Modifications
 */
export var updateScreenTabs = function updateScreenTabs(_ref) {
  var screenTabsFromIframe = _ref.screenTabsChanges,
    changeId = _ref.changeId,
    appId = _ref.appId;
  return function (_ref2) {
    var getState = _ref2.getState,
      setState = _ref2.setState,
      dispatch = _ref2.dispatch;
    var _getState = getState(),
      internalScreenTabs = _getState.screenTabs;
    // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
    if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) {
      return;
    }
    if (internalScreenTabs && screenTabsPublicToInternalValidator(internalScreenTabs, screenTabsFromIframe)) {
      var newScreenTabs = screenTabsPublicToInternalTransformer(internalScreenTabs, screenTabsFromIframe);
      setState({
        screenTabs: newScreenTabs
      });
      dispatch(collectScreenTabsAppliedChangesHistory({
        appId: appId,
        changeId: changeId,
        screenTabs: newScreenTabs
      }));
    } else {
      throw new UiModificationsScreenTabsValidationError('Transformation failed', {
        errors: getScreenTabsPublicToInternalValidationErrors(internalScreenTabs, screenTabsFromIframe).map(toScreenTabsValidationError)
      });
    }
  };
};